import { createReducer, INITIAL_STATE } from '@shared/redux';

export const OPEN_NEW_CAMPAIGN_MODAL = '@mobees/newCampaign/OPEN_NEW_CAMPAIGN_MODAL';
export const CLOSE_NEW_CAMPAIGN_MODAL = '@mobees/newCampaign/CLOSE_NEW_CAMPAIGN_MODAL';
export const CHANGE_NEW_CAMPAIGN_MODAL_STEP = '@mobees/newCampaign/CHANGE_NEW_CAMPAIGN_MODAL_STEP';
export const RESET_INTERFACE = '@mobees/newCampaign/RESET_INTERFACE';

export interface NewCampaignInterfaceState {
    newCampaignModalOpen: boolean;
    activeStep: number;
}

export const openNewCampaignModal = (params: any = {}) => ({
    type: OPEN_NEW_CAMPAIGN_MODAL,
    payload: {
        params,
    },
});

export const closeNewCampaignModal = () => ({
    type: CLOSE_NEW_CAMPAIGN_MODAL,
    payload: {},
});

export const changeNewCampaignModalStep = step => ({
    type: CHANGE_NEW_CAMPAIGN_MODAL_STEP,
    payload: {
        step,
    },
});

export const resetInterface = () => ({
    type: RESET_INTERFACE,
    payload: {},
});

export const getIsModalOpen = state => state.partnerships.mobees
    .newCampaign.interface.newCampaignModalOpen;

export const getStep = state => state.partnerships.mobees.newCampaign.interface.activeStep;

const initialState: NewCampaignInterfaceState = {
    newCampaignModalOpen: false,
    activeStep: 1,
};

export const newCampaignInterfaceReducer = createReducer({
    [INITIAL_STATE]: initialState,
    [OPEN_NEW_CAMPAIGN_MODAL]: state => ({
        ...state,
        newCampaignModalOpen: true,
    }),
    [CLOSE_NEW_CAMPAIGN_MODAL]: state => ({
        ...state,
        newCampaignModalOpen: false,
    }),
    [CHANGE_NEW_CAMPAIGN_MODAL_STEP]: (state, action) => ({
        ...state,
        activeStep: action.payload.step,
    }),
    [RESET_INTERFACE]: () => initialState,
});
